"use client";

import { useEffect } from "react";

export default function DomainError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Domain error:", error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-grunge px-6 text-center">
      <h1 className="mb-2 text-5xl font-bold text-white">500</h1>
      <h2 className="mb-3 text-xl font-semibold text-white">
        Something went wrong
      </h2>
      <p className="mb-8 max-w-md text-base leading-relaxed text-grunge60 dark:text-grunge30">
        We ran into an unexpected error. Please try again or come back later.
      </p>
      <button
        onClick={reset}
        className="rounded-lg bg-purpleDub px-6 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90"
      >
        Try again
      </button>
    </div>
  );
}
